import React from "react";
import { useImmer } from "use-immer";
import UtilService from "../../service/UtilService";
import AuditlogMetadataService from "../../service/AuditlogMetadataService";
import AuditlogExpandedRow from "./AuditlogExpandedRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const AuditlogTable = ({ auditlogs, displayedAttributes }) => {
  const [expandedRows, updateExpandedRows] = useImmer([]);

  const toggleRow = (auditlogId) => {
    updateExpandedRows((draft) => {
      const index = draft.indexOf(auditlogId);
      if (index > -1) {
        draft.splice(index, 1);
      } else {
        draft.push(auditlogId);
      }
    });
  };

  if (!displayedAttributes || displayedAttributes.length === 0) {
    return null;
  }

  return (
    <table className="config-table-double auditlog-table">
      <thead>
        <tr>
          {displayedAttributes.map((attr) => (
            <th key={attr}>
              {attr === "actions" ? "" : UtilService.camelCaseToReadable(attr)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {auditlogs.length === 0 && (
          <tr>
            <td
              colSpan={displayedAttributes.length}
              style={{ textAlign: "center", padding: "2em" }}
            >
              No audit logs found.
            </td>
          </tr>
        )}

        {auditlogs.map((log) => (
          <React.Fragment key={log.id}>
            {/* Main row */}
            <tr
              onClick={() => toggleRow(log.id)}
              className="auditlog-row-clickable"
            >
              {displayedAttributes.includes("id") && (
                <td className="use-mono-font">{log.id}</td>
              )}
              {displayedAttributes.includes("eventType") && (
                <td>
                  <div style={{ maxWidth: "280px", overflowX: "auto", whiteSpace: "nowrap", maskImage: "linear-gradient(to right, black 80%, transparent 100%)", WebkitMaskImage: "linear-gradient(to right, black 80%, transparent 100%)" }}>
                    {log.eventType}
                  </div>
                </td>
              )}
              {displayedAttributes.includes("created") && (
                <td className="use-mono-font">
                  {UtilService.isoDateToReadable(log.created)}
                </td>
              )}
              {displayedAttributes.includes("userId") && <td>{log.userId}</td>}
              {displayedAttributes.includes("newValue") && (
                <td className="auditlog-value-truncated">
                  {AuditlogMetadataService.extractNewValue(
                    log.metadata,
                    log.eventType,
                  )}
                </td>
              )}
              {displayedAttributes.includes("oldValue") && (
                <td className="auditlog-value-truncated">
                  {AuditlogMetadataService.extractOldValue(
                    log.metadata,
                    log.eventType,
                  )}
                </td>
              )}
              {displayedAttributes.includes("description") && (
                <td className="auditlog-value-truncated">{log.description}</td>
              )}
              {displayedAttributes.includes("action") && (
                <td>{log.metadata?.action || "-"}</td>
              )}
              {displayedAttributes.includes("targetType") && (
                <td>{log.metadata?.targetType || "-"}</td>
              )}
              {displayedAttributes.includes("actions") && (
                <td className="auditlog-action-cell">
                  <FontAwesomeIcon
                    icon={
                      expandedRows.includes(log.id) ? faChevronUp : faChevronDown
                    }
                    className="auditlog-expand-icon"
                  />
                </td>
              )}
            </tr>

            {/* Expanded detail row */}
            {expandedRows.includes(log.id) && (
              <tr>
                <td
                  colSpan={displayedAttributes.length}
                  className="auditlog-expanded-row"
                >
                  <AuditlogExpandedRow auditlog={log} />
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default AuditlogTable;
